import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import { CmpsButtonModule, CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';

import { DateRangeComponent } from './date-range.component';
import { TranslationIdMap } from './date-range.component.i18n';

@NgModule({
    declarations: [DateRangeComponent],
    exports: [DateRangeComponent],
    imports: [
        CmpsButtonModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        FormsModule,
        NgbModule,
    ],
})
export class CmpsDateRangeModule {}
